import cx from "classnames";
import React, { memo, useMemo, useState } from "react";
import t from "../../../../../../../../../../i18n";
import { AddCircleLine } from "@ui/IconV2/react";
import Popper from "@ui/Popper";
import Text from "@ui/Text";
import { useGUIEditorContext } from "../../../../../../../hook/context/gui";
import { useLayerUpdateEncodingCallback } from "../../hook/useLayerUpdateEncodingCallback";
import { ResourceSelectorMenu } from "./ResourceSelectorMenu";
import TooltipV2 from "@ui/TooltipV2";
import Button from "@ui/Button";
import { css } from "@linaria/core";
import { colors } from "@ui/Theme";

const resourceSelector = css`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

const resourceSelectorTitle = css`
  color: ${colors.carbon900};
`;

export const ResourceSelector = memo(
  ({ projectId, className }: { projectId: string; className?: string }) => {
    const { preset, block } = useGUIEditorContext();
    const [opened, setOpened] = useState(false);
    const onResourceSelect = useLayerUpdateEncodingCallback();

    const disableResourceAddition = useMemo(
      () =>
        preset === "scatter" &&
        (block?.config.layers.length ?? 0) > 0 &&
        (block?.config.layers[0]?.encoding.x.identifier.length ?? 0) > 0 &&
        (block?.config.layers[0]?.encoding.x.column.length ?? 0) > 0 &&
        (block?.config.layers[0]?.encoding.y.identifier.length ?? 0) > 0 &&
        (block?.config.layers[0]?.encoding.y.column.length ?? 0) > 0,
      [preset, block],
    );

    return (
      <div className={cx(resourceSelector, className)}>
        <Text type="body1SemiBold" className={resourceSelectorTitle}>
          {t("project.dashboard.editor.gui.section.data.title")}
        </Text>
        <Popper
          opened={opened}
          setOpened={setOpened}
          backgroundColor="transparent"
          placement="left-start"
          overlay={
            <ResourceSelectorMenu
              projectId={projectId}
              onResourceSelect={value => {
                onResourceSelect(value);
                setOpened(false);
              }}
            />
          }
        >
          <div>
            <TooltipV2 overlay={t("tooltip.editor.plot.add_data")}>
              <Button
                onClick={() => setOpened(s => !s)}
                disabled={disableResourceAddition}
                leftIcon={<AddCircleLine />}
                variant="tertiary"
                slim
              >
                {t("project.dashboard.editor.gui.section.data.add_button")}
              </Button>
            </TooltipV2>
          </div>
        </Popper>
      </div>
    );
  },
);
